import { useEffect, useState } from 'react';
import { subscribeContent, emptyContent } from '../lib/content';

/**
 * Live site content.
 *
 * `errors` is keyed by section — non-empty means Firestore refused or failed,
 * which is a different situation from an empty database and must be shown as
 * such. Falls back to the bundled seed when Firebase isn't configured at all.
 */
export default function useContent() {
  const [state, setState] = useState(() => ({
    content: emptyContent(),
    loading: true,
    source: null,
    errors: {},
  }));

  useEffect(() => {
    const unsub = subscribeContent((content, source, errors) => {
      setState({ content, loading: false, source, errors: errors || {} });
    });
    return unsub;
  }, []);

  return state;
}
